import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {useRouteQueryKey} from '@github-ui/react-core/future/use-route-query-key'
import {pullRequestsOverviewRoute} from '../../../routes/overview-route'

export function useOverviewRouteData() {
  return useRouteQuery(pullRequestsOverviewRoute, 'mainQuery')
}

export function useOverviewRouteQueryKey() {
  return useRouteQueryKey(pullRequestsOverviewRoute, 'mainQuery')
}
